import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export const useExchangeStockLocations = ({
  articleId,
  query = {},
  options,
}: {
  articleId: string;
  query?: Endpoints['GET /articles/:id/exchange-stock-locations']['query'];
  options?: { enabled?: boolean; keepPreviousData?: boolean };
}) => {
  const fetch = useFetch<Endpoints['GET /articles/:id/exchange-stock-locations']>();

  return useQuery({
    queryKey: ['exchange-stock-locations', articleId, query],
    queryFn: () => fetch(`/articles/${articleId}/exchange-stock-locations`, query),
    enabled: options?.enabled,
    placeholderData: options?.keepPreviousData ? keepPreviousData : undefined,
  });
};

export const useUpdateArticleExchange = (articleId: string) => {
  const queryClient = useQueryClient();
  const fetch = useFetch<Endpoints['PATCH /articles/:id/exchange']>();

  return useMutation({
    mutationFn: (body: Endpoints['PATCH /articles/:id/exchange']['body']) =>
      fetch(`/articles/${articleId}/exchange`, undefined, { method: 'PATCH', body }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['requests'] });
    },
  });
};
